import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

/**
 * React wrapper for Bryntum TaskBoardBase
 */
import React, { Component } from 'react';
import WrapperHelper from './WrapperHelper.js';
import { TaskBoardBase } from '@bryntum/taskboard/taskboard.umd';

var BryntumTaskBoardBase = /*#__PURE__*/function (_Component) {
  _inherits(BryntumTaskBoardBase, _Component);

  var _super = _createSuper(BryntumTaskBoardBase);

  function BryntumTaskBoardBase() {
    var _this;

    _classCallCheck(this, BryntumTaskBoardBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.dataStores = {};
    _this.projectStores = undefined;
    _this.featureNames = ['columnDragFeature', 'columnHeaderMenuFeature', 'columnToolbarsFeature', 'simpleTaskEditFeature', 'swimlaneDragFeature', 'taskDragFeature', 'taskDragSelectFeature', 'taskEditFeature', 'taskMenuFeature', 'taskTooltipFeature'];
    _this.portalsCache = undefined;
    _this.portalContainerClass = 'b-react-portal-container';
    _this.state = {
      // Holds React portals
      portals: new Map(),
      // Needed to trigger refresh when portals change
      generation: 0
    };
    _this.configNames = ['activateTaskEvent', 'adopt', 'align', 'anchor', 'appendTo', 'autoGenerateColumns', 'autoGenerateSwimlanes', 'bbar', 'bodyCls', 'breakpoints', 'bubbleEvents', 'cardSizes', 'centered', 'cls', 'collapsed', 'collapseTitle', 'collapsible', 'columnField', 'config', 'constrainTo', 'contentElementCls', 'cssVarPrefix', 'defaultBindProperty', 'defaults', 'dock', 'draggable', 'floating', 'footer', 'header', 'hideAnimation', 'hideWhenEmpty', 'htmlCls', 'insertBefore', 'insertFirst', 'itemCls', 'keyMap', 'lazyItems', 'listeners', 'loadMask', 'loadMaskDefaults', 'loadMaskError', 'localeClass', 'localizableProperties', 'maskDefaults', 'masked', 'monitorResize', 'namedItems', 'newTaskDefaults', 'owner', 'plugins', 'positioned', 'preventTooltipOnTouch', 'processItems', 'project', 'resourceImagePath', 'ripple', 'rootElement', 'scrollAction', 'scrollManager', 'scrollOptions', 'selectOnNavigation', 'showAnimation', 'showCollapseInHeader', 'showCountInHeader', 'showTooltipWhenDisabled', 'stickyHeaders', 'strips', 'swimlaneField', 'swimlaneRenderer', 'syncMask', 'tab', 'tag', 'taskRenderer', 'tasksPerRow', 'tbar', 'textAlign', 'textContent', 'title', 'trapFocus', 'ui', 'useDomTransition', 'weight'];
    _this.propertyConfigNames = ['alignSelf', 'bodyItems', 'columns', 'content', 'css', 'dataset', 'disabled', 'extraData', 'features', 'flex', 'footerItems', 'headerItems', 'height', 'hidden', 'html', 'id', 'items', 'layout', 'layoutStyle', 'margin', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'onActivateTask', 'onBeforeColumnDrag', 'onBeforeColumnDrop', 'onBeforeDestroy', 'onBeforeHide', 'onBeforeSetRecord', 'onBeforeShow', 'onBeforeTaskDrag', 'onBeforeTaskDrop', 'onCatchAll', 'onCellMenuItem', 'onCellMenuShow', 'onCellMenuToggleItem', 'onColumnDrag', 'onColumnDragAbort', 'onColumnDragEnd', 'onColumnDragStart', 'onColumnDrop', 'onColumnHeaderMenuBeforeShow', 'onDestroy', 'onFocusIn', 'onFocusOut', 'onHide', 'onPaint', 'onReadOnly', 'onRemoveTaskElement', 'onRenderTask', 'onResize', 'onResponsiveHeightChange', 'onResponsiveWidthChange', 'onSelectionChange', 'onShow', 'onTaskClick', 'onTaskDblClick', 'onTaskDrag', 'onTaskDragAbort', 'onTaskDragEnd', 'onTaskDragStart', 'onTaskDrop', 'onTaskMenuBeforeShow', 'onTaskMouseEnter', 'onTaskMouseLeave', 'onToolClick', 'readOnly', 'scrollable', 'selectedTasks', 'swimlanes', 'tools', 'tooltip', 'width', 'x', 'y'];
    _this.propertyNames = ['anchorSize', 'isSettingValues', 'isValid', 'record', 'state', 'values'];
    _this.instance = undefined;
    _this.element = undefined;
    return _this;
  }

  _createClass(BryntumTaskBoardBase, [{
    key: "componentDidMount",
    value:
    /**
     * Invoked immediately after a component is mounted (inserted into the tree)
     */
    function componentDidMount() {
      var _WrapperHelper = WrapperHelper(),
          createWidget = _WrapperHelper.createWidget;

      this.instance = createWidget(this);
    } // React component removed, destroy instance

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.destroy();
      }
    }
    /**
     * Component about to be updated, from changing a prop using state.
     * React to it depending on what changed and prevent react from re-rendering our component.
     * @param nextProps
     * @param nextState
     * @return {boolean}
     */

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _WrapperHelper2 = WrapperHelper(),
          shouldComponentUpdate = _WrapperHelper2.shouldComponentUpdate;

      return shouldComponentUpdate(this, nextProps, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = "b-react-".concat(this.constructor.instanceClass.$name.toLowerCase(), "-container");
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: function ref(element) {
          return _this2.element = element;
        }
      }, _toConsumableArray(this.state.portals).map(function (item) {
        return item[1];
      })), /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return _this2.portalsCache = el;
        },
        className: "b-react-portals-cache",
        style: {
          display: 'none'
        }
      }));
    }
  }]);

  return BryntumTaskBoardBase;
}(Component);

BryntumTaskBoardBase.instanceClass = TaskBoardBase;
BryntumTaskBoardBase.isView = true;
export { BryntumTaskBoardBase as default };